@let latestInstallations = (filteredLatestInstallations$ | async);

@if (showSiteSearch()) {
  <div
    class="fixed inset-0 bg-secondary-800/50 backdrop-blur-md z-[99999] flex justify-center md:pt-[10vh]"
    (click)="closeWindow()">
    <div class="flex flex-col overflow-hidden bg-secondary-50/80 w-full md:w-auto max-w-200 md:min-w-200 min-h-50 md:max-h-[80vh] md:rounded-4xl pt-2"
      StopPropagation>
      <div class="pl-3 pr-1.5">
        <div class="flex md:px-3 md:pt-2 pb-3">
          <form class="mr-auto flex items-center w-full" [formGroup]="form">
            <mat-icon>search</mat-icon>
            <input class="h-12 w-full focus:outline-0 pl-3 placeholder:text-base"
              [placeholder]="'SITE_SEARCH.SEARCH_INPUT_PLACEHOLDER' | translate" #siteSearchInput formControlName="search"
              autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">
            </form>
            <div>
              <button mat-icon-button (click)="closeWindow()" class="text-grey-600 hover:text-grey-800">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="h-0.5 overflow-hidden">
          <div class="h-full bg-gradient-to-r from-0% via-90% to-[100%] from-transparent via-green-400 to-transparent [animation-duration:1.5s] invisible"
          [ngClass]="{ 'animate-loading-bar visible' : isLoading()}"></div>
        </div>
        <div class="overflow-y-auto pt-2 pb-4">
          @if (latestInstallations) {
            <section class="pb-3">
              @if (latestInstallations.length > 0) {
                <h2 class="text-sm text-grey-700 px-2 md:px-6 pb-2">{{ "SITE_SEARCH.RECENT" | translate}}</h2>
              }
              @for (latestInst of latestInstallations; let i = $index; track latestInst.refCode) {
                <a [routerLinkSubDomain]="latestInst.urlPrefix" [routerLink]="[ latestInst.refCode, 'dashboard' ]" (click)="closeWindow()"
                  class="flex py-3 px-2 md:px-6 hover:bg-primary-400/10 cursor-pointer" tabindex="0"
                  [ngClass]="{'bg-grey-50/70': i === selectedIndex()}">
                  <div class="mr-3 flex flex-col md:flex-row items-center">
                    <mat-icon class="scale-65 text-grey-500 md:mr-2">history</mat-icon>
                    <mat-icon class="scale-90 mr-1" [ngClass]="iconClassName(latestInst.type)">{{
                    iconName(latestInst.type) }}</mat-icon>
                  </div>
                  <div class="flex-grow min-h-12 flex items-center">
                    <div>
                      <div class="">
                        @for (p of latestInst.parentsFlat; let idx = $index; track idx) {
                          @if (idx) {
                            <span class="mr-1 text-xs">></span>
                          }
                          <a [routerLinkSubDomain]="p.urlPrefix" [routerLink]="[ p.refCode , 'dashboard' ]" (click)="closeWindow()"
                            class="wrap-anywhere mr-2 min-w-0 text-2xs text-secondary-500 visited:text-secondary-500 hover:text-primary-400 no-underline">
                          {{ p.name }}</a>
                        }
                      </div>
                      <div class="text-grey-700 text-base">
                        @if (latestInst.alias) {
                          <span class="mr-1 wrap-anywhere"
                          [innerHTML]="(latestInst.alias | highlight : controls.search.value || '')"></span>
                        }
                        <span class="wrap-anywhere"
                        [innerHTML]="(latestInst.name | highlight : controls.search.value || '')"></span>
                        <span class="ml-2 text-sm text-primary-500 wrap-anywhere"
                        [innerHTML]="(latestInst.refCode | highlight : controls.search.value || '')"></span>
                      </div>
                      <div class="italic text-grey-500 text-2xs leading-3 pb-0.5"
                        [innerHTML]="(latestInst.address| highlight : controls.search.value || '')">
                      </div>
                    </div>
                  </div>
                  <div class="flex items-center">
                    <button mat-icon-button
                      class="scale-90 text-grey-700 hover:text-grey-900"><mat-icon>arrow_outward</mat-icon></button>
                    </div>
                  </a>
                }
              </section>
            }
            @if ((filteredInstallations$ | async); as filteredInstallations) {
              <section class="pb-3">
                @if (filteredInstallations.length > 0) {
                  <h2 class="text-sm text-grey-700 px-2 md:px-6 pb-2">{{ "SITE_SEARCH.SUGGESTIONS" | translate}}
                  </h2>
                }
                @for (inst of filteredInstallations; let i = $index; track inst.refCode) {
                  <a  [routerLinkSubDomain]="inst.urlPrefix" [routerLink]="[ inst.refCode, 'dashboard' ]" (click)="closeWindow()"
                    class="flex py-3 px-2 md:px-6 hover:bg-primary-400/10 cursor-pointer" tabindex="0"
                    [ngClass]="{'bg-grey-50/70': i + (latestInstallations?.length ?? 0) === selectedIndex()}">
                    <div class="mr-3 flex flex-col md:flex-row items-center">
                      <mat-icon class="scale-90 mr-1" [ngClass]="iconClassName(inst.type)">{{
                      iconName(inst.type) }}</mat-icon>
                    </div>
                    <div class="flex-grow min-h-12 flex items-center">
                      <div>
                        <div class="">
                          @for (p of inst.parentsFlat; let i = $index; track i) {
                            @if (i) {
                              <span class="mr-1 text-xs">></span>
                            }
                            <a [routerLinkSubDomain]="p.urlPrefix" [routerLink]="[ p.refCode, 'dashboard']" (click)="closeWindow()"
                              class="wrap-anywhere mr-2 min-w-0 text-2xs text-secondary-500 visited:text-secondary-500 hover:text-primary-400 no-underline">
                            {{ p.name }}</a>
                          }
                        </div>
                        <div class="text-grey-700 text-base">
                          @if (inst.alias) {
                            <span class="mr-1 wrap-anywhere"
                            [innerHTML]="(inst.alias | highlight : controls.search.value || '')"></span>
                          }
                          <span class="wrap-anywhere"
                          [innerHTML]="(inst.name | highlight : controls.search.value || '')"></span>
                          <span class="ml-2 text-sm text-primary-500 wrap-anywhere"
                          [innerHTML]="(inst.refCode| highlight : controls.search.value || '')"></span>
                        </div>
                        <div class="italic text-grey-500 text-2xs leading-3 pb-0.5"
                          [innerHTML]="(inst.address| highlight : controls.search.value || '')">
                        </div>
                      </div>
                    </div>
                    <div class="flex items-center">
                      <button mat-icon-button
                        class="scale-90 text-grey-700 hover:text-grey-900"><mat-icon>arrow_outward</mat-icon></button>
                      </div>
                    </a>
                  }
                </section>
              }
              @if (fullResult().length === 0 && isLoading()) {
                <section>
                  <div class="h-20 flex items-center justify-center">
                    <span class="text-grey-400">{{ "SITE_SEARCH.LOADING" | translate }}</span>
                  </div>
                </section>
              }
              @if (fullResult().length === 0 && form.controls['search'].value && !isLoading()) {
                <section>
                  <div class="h-20 flex items-center justify-center">
                    <span class="text-grey-400">{{ "SITE_SEARCH.NO_RESULT" | translate: { value: controls.search.value || '' } }}</span>
                  </div>
                </section>
              }
            </div>
          </div>
        </div>
      }